import { LayerGroupIds } from "fond/layers";

import AddressHandler from "./addresses/AddressHandler";
import AerialHandler from "./aerial/AerialHandler";
import CentralOfficeHandler from "./centralOffice/CentralOfficeHandler";
import HubHandler from "./hubs/HubHandler";
import LeadInHandler from "./modes/design/leadIns/LeadInHandler";
import UndergroundHandler from "./modes/design/underground/UndergroundHandler";
import PathHandler from "./underground/PathHandler";

const handlers: Record<keyof typeof LayerGroupIds, React.ReactNode> = {
  inBaseDataStreet: <PathHandler layerId="input_layers/streets" />,
  inAddress: <AddressHandler />,
  spanPole: <AerialHandler />,
  inExchange: <CentralOfficeHandler />,
  hub: <HubHandler />,
  inStreet: <PathHandler layerId="input_layers/ug_path" />,
  inLeadIns: <LeadInHandler />,
  inUnderground: <UndergroundHandler />,
};

/**
 * Factory function to return the appropriate draw handler
 * for a given layer group ID. These handlers are used to draw features
 * on the map for different layer groups and are passed to the Map component
 * for rendering.
 *
 * @param {keyof typeof LayerGroupIds} layerGroupId - The ID of the layer group
 * for which the corresponding handler component is required.
 * @returns {React.ReactNode} The React component handler corresponding to the
 * provided layer group ID.
 */
export const drawHandlerFactory = (layerGroupId: keyof typeof LayerGroupIds): React.ReactNode => {
  return handlers[layerGroupId];
};
